﻿import {CardItemLabel} from "../CardItemLabel";
import {withGrayTransparency} from "../../../../hocs/withGrayTransparency";

export const CardItemLabelWithGray = withGrayTransparency(CardItemLabel);
